import React, { useEffect, useState } from "react";
import { Table, TableCell, TableRow, Typography } from "@mui/material";
import { cnpjMask } from "../../../Services/cnpjMask";
import { cpfMask } from "../../../Services/cpfMask";
import { ModalTransmitente } from "./ModalTransmitente";
import { Container } from "./styles";
import theme from "../../../Styles/theme";
import { Button } from "@mui/material";
import {
  AddCircle as PlusIcon,
  Edit as EditIcon,
  Delete as TrashIcon,
} from "@mui/icons-material";
import { useTransmitente } from "../../../Storage/Transmitente";
import { ExcluirModal } from "./ExcluirModal";

export interface ITransmitente {
  ID: string;
  NOME: string;
  RUA: string;
  NUMERO: number;
  BAIRRO: string;
  COMPLEMENTO: string;
  IMOVEL_ID: number;
  IMOVEL_RURAL_ID: number;
  EMAIL: string;
  FONE: string;
  WHATS: string;
  CPF: string;
  CNPJ: string;
  MUNICIPIO: string;
  UF: string;
}

interface Props {
  transmitente: ITransmitente;
  handleSetTransmitente(n_transmitente: ITransmitente): void;
  editavel: boolean;
}

export function Transmitente({ handleSetTransmitente, editavel,}: Props) {
  // editavel = true;
  const [openModal, setOpenModal] = useState(false);
  const [openModalExcluir, setOpenModalExcluir] = useState(false);

  const [cpf_cnpj, set_cpf_cnpj] = useState("");
  const { transmitentes, setTransmitentes } = useTransmitente();
  const [transmitenteFocus, setTransmitenteFocus] = useState(
    {} as ITransmitente
  );
  // useEffect(() => {
  //   if (transmitente.CPF) {
  //     set_cpf_cnpj(transmitente.CPF);
  //   }
  //   if (transmitente.CNPJ) {
  //     set_cpf_cnpj(transmitente.CNPJ);
  //   }
  // }, [transmitente]);

  return (
    <>
      <Container
        onClick={() => {}}
        style={{
          padding: "0",
          margin: "3px",
        }}
        interactive={editavel}
      >
        {transmitentes &&
          transmitentes.length > 0 &&
          transmitentes.map((transmitente) => (
            <div
              style={{
                marginBottom: "4px",
                border: "1px solid rgba(224, 224, 224, 1)",
              }}
            >
              <div style={{}}>
                <Table
                  size="small"
                  style={{
                    border: "1px solid rgba(224, 224, 224, 1)",
                    background: theme.colors.light,
                    borderRadius: "0.25rem",
                    padding: "0",
                  }}
                >
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "40%",
                      }}
                    >
                      Nome
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "20%",
                      }}
                    >
                      {transmitente.CPF ? "CPF" : "CNPJ"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "38%",
                      }}
                    >
                      Município
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "2%",
                      }}
                    >
                      UF
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                      }}
                    >
                      {transmitente.NOME
                        ? transmitente.NOME.toUpperCase()
                        : "?"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                      }}
                    >
                      {transmitente.CPF || transmitente.CNPJ
                        ? transmitente.CNPJ
                          ? cnpjMask(transmitente.CNPJ)
                          : cpfMask(transmitente.CPF)
                        : "?"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                      }}
                    >
                      {transmitente.MUNICIPIO
                        ? transmitente.MUNICIPIO.toUpperCase()
                        : "?"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                      }}
                    >
                      {transmitente.UF ? transmitente.UF.toUpperCase() : "?"}
                    </TableCell>
                  </TableRow>
                </Table>

                <Table
                  size="small"
                  style={{
                    border: "1px solid rgba(224, 224, 224, 1)",
                    background: theme.colors.light,
                    borderRadius: "0.25rem",
                    padding: 0,
                  }}
                >
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      Bairro
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      Rua
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      Número
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      Complemento
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      {transmitente.BAIRRO
                        ? transmitente.BAIRRO.toUpperCase()
                        : "?"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      {transmitente.RUA ? transmitente.RUA.toUpperCase() : "?"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      {transmitente.NUMERO ? transmitente.NUMERO : "?"}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        padding: "0",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        width: "25%",
                      }}
                    >
                      {transmitente.COMPLEMENTO
                        ? transmitente.COMPLEMENTO.toUpperCase()
                        : "?"}
                    </TableCell>
                  </TableRow>
                </Table>
              </div>
              {editavel ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    marginBottom: "2px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{ background: theme.colors.attention, fontSize: 10 }}
                    startIcon={<TrashIcon />}
                    onClick={() => {
                      setTransmitenteFocus(transmitente);
                      setOpenModalExcluir(true);
                    }}
                  >
                    Excluir Transmitente
                  </Button>

                  <Button
                    variant="contained"
                    style={{ fontSize: 10 }}
                    startIcon={<EditIcon />}
                    onClick={() => {
                      setTransmitenteFocus(transmitente);
                      setOpenModal(true);
                    }}
                  >
                    Editar Transmitente
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
          ))}

        {editavel && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "4px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusIcon />}
              onClick={() => {
                setTransmitenteFocus({} as ITransmitente);
                setOpenModal(true);
              }}
              style={{ minWidth: "300px" }}
            >
              Adicionar Transmitente
            </Button>
          </div>
        )}
      </Container>
      {editavel ? (
        <>
          <ModalTransmitente
            handleSetTransmitente={handleSetTransmitente}
            open={openModal}
            onClose={() => setOpenModal(false)}
            transmitente={transmitenteFocus}
          />
          <ExcluirModal
            open={openModalExcluir}
            onClose={() => setOpenModalExcluir(false)}
            transmitente={transmitenteFocus}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
}
